module.exports = __webpack_public_path__ + "chefy-medico.png?2039ef4205bf4b974c52204cabf4d23f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-medico.png
// module id = 36
// module chunks = 0